import { de } from "./de";
import { en } from "./en";
import {
  DEFAULT_LOCALE,
  LOCALE_STORAGE_KEY,
  LOCALES,
  type Locale,
  type Messages,
} from "./types";

export type { Locale, Messages };
export { DEFAULT_LOCALE, LOCALES, LOCALE_STORAGE_KEY };

const catalogs: Record<Locale, Messages> = { en, de };

export function isLocale(value: string | null | undefined): value is Locale {
  return value === "en" || value === "de";
}

export function readStoredLocale(): Locale {
  try {
    const raw = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (isLocale(raw)) return raw;
  } catch {
    // ignore
  }
  return DEFAULT_LOCALE;
}

export function writeStoredLocale(locale: Locale): void {
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    // ignore
  }
}

export function messagesFor(locale: Locale): Messages {
  return catalogs[locale] ?? catalogs[DEFAULT_LOCALE];
}

export function acceptLanguageHeader(locale: Locale): string {
  return locale === "de" ? "de, en;q=0.8" : "en, de;q=0.5";
}

/** Simple `{name}` interpolation for dictionary strings. */
export function formatMessage(template: string, vars?: Record<string, string | number>): string {
  if (!vars) return template;
  return template.replace(/\{(\w+)\}/g, (_, key: string) =>
    vars[key] == null ? `{${key}}` : String(vars[key]),
  );
}

export function statusLabel(m: Messages, value: string): string {
  return m.status[value] ?? value;
}
